//angular imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

//local imports
import { AbstractStatusModel } from '@app/catalog-common';

@Component({
  selector: 'status-item',
  standalone: false,
  templateUrl: './status-item.component.html',
  styleUrl: './status-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusItemComponent {
  public status = input.required<AbstractStatusModel>();
}
